import { useContext, useState, useCallback } from 'react';
// import CollegeSearch from './CollegeSearch';
// import TopColleges from './TopColleges';
// import TopSearchTab from './TopSearchTab';
// import TopCollegesTab from './TopCollegesTab';
// import CompareColleges from './CompareColleges';
// import CollegeService from './CollegeService';
import { SmartContext } from '../../library/Core/SmartContext';
import { GlobalContext } from '../../library/Core/GlobalContext';
import { useLoaderData } from 'react-router-dom';
import { State } from '../../library/Core/SmartTypes';
import CareerInterestMatch from './CareerInterestMatch';
import CareerFilter from './CareerFilter';
import CareerDeepList from './CareerDeepList';

// Define the structure for filters
interface FilterState {
  departments: (string | number)[];
  likes: string[];
  abilities: string[];
}

const TopCareerLayout = (props: any) => {
    
    const { state, dispatch } = useContext(SmartContext);
    const { globalState } = useContext(GlobalContext);

    const { formConfig, data, internal } = useLoaderData() as State;

    const [resetKey, setResetKey] = useState(0);
    const [selectedFilters, setSelectedFilters] = useState<FilterState>({
        departments: [],
        likes: [],
        abilities: [],
    });

    const handleFilterChange = useCallback((filters: FilterState) => {
        setSelectedFilters(filters);
    }, []);
    
    const handleClearFilters = () => {
        // if there are any filters applied, clear them
        setSelectedFilters({
            departments: [],
            likes: [],
            abilities: [],
        });
        // Increment reset key to force a re-render
        setResetKey(key => key + 1);
        
        const currentUrl = window.location.href;

        if (currentUrl.includes("like") || currentUrl.includes("department") || currentUrl.includes("ability")) {
        // window.location.href = `/careers`;
        // clear the URL parameters
        const url = new URL(currentUrl);
        url.searchParams.delete("like");
        url.searchParams.delete("department");
        url.searchParams.delete("ability");
        window.history.replaceState({}, document.title, url.toString());
        }       
        // Redirect to the appropriate URL
        // window.location.href = `/careers`;
    };
    
    async function topCollegeFilter(rank:any): Promise<any> {
        // const state: any = {};
        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig,data, domain: globalState.domain, internal,flags:{isDataLoading:true} },
        });
        
        var topCollegeUrl = `?has_ranking=${rank}`;
        
        const response = await Promise.all([
            // CollegeService.getTopCollegeFilter(topCollegeUrl),
            //mocking empty response for CollegeService.getTopCollegeFilter
            Promise.resolve({ data: { data: [] } })
        ]);
        // console.log('response---Filter-- JSON' + JSON.stringify(response[0]?.data.data));
        dispatch({
            type: 'DATA_INIT',
            payload: {
                formConfig,
                data: { ...data, topCollegeList: response[0]?.data.data ?? [] },
                domain: globalState.domain,
                internal,
                flags: { isDataLoading: false }
            },
        });
        return await Promise.resolve(state);
    }

    // Remove 'show' class from the filter collapse container on button click
    const handleFilterButtonClick = (e: any) => {
        const el = document.getElementById('filter_collapse');
        if (el) {
            // Run after bootstrap's data-api (if present) so our removal takes precedence
            setTimeout(() => el.classList.remove('show'), 0);
        }
    };

    return (
        <>
            
            <div className="main flex-1">
                <div className="max-1140 mx-auto d-flex flex-column h-100">
                    <div className="m-w-90 d-flex flex-column justify-content-between  pt-5 mb-3">
                        <h3 className="font-35 font-600 mb-0 block-title aos-init aos-animate">Choose Your Career</h3>
                        <p className="font-18 font-400 mb-2">
                            Use the college finder tool to find the best colleges! Choose from the following options.
                        </p>
                    </div>

                    <div className="job_internship_tab polartabsec bg-white radius-6">
                        <div className="xscroll p-0 pb-2 pb-md-0 position-static">
                            <ul className="nav nav-tabs aos-init aos-animate" id="JobInternshipTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button
                                        onClick={() => topCollegeFilter(1)}
                                        className="nav-link active"
                                        id="careerdeepdive-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#careerdeepdive"
                                        type="button"
                                        role="tab"
                                        aria-controls="careerdeepdive"
                                        aria-selected="false">
                                        Career Deep Dive
                                    </button>
                                </li>
                                {
                                    <li className="nav-item" role="presentation">
                                        <button
                                            onClick={() => topCollegeFilter(2)}
                                            className="nav-link"
                                            id="careerinterestmatch-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#careerinterestmatch"
                                            type="button"
                                            role="tab"
                                            aria-controls="careerinterestmatch"
                                            aria-selected="true">
                                            Career Interest Match
                                        </button>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>

                    <div className="tab-content" id="myTabMainContent">
                        <div className="tab-pane fade active show" id="careerdeepdive" role="tabpanel" aria-labelledby="careerdeepdive-tab">
                            <div className="row g-4 pt-4 pb-5 JobInternshipListing">
                                {/* <div className="col-md-auto">
                                    
                                    <CareerFilter onFilterChange={handleFilterChange} />
                                </div>
                                <div className="col-md">
                                    <CareerDeepList filters={selectedFilters} />
                                </div> */}

                                <div className="col-md-auto">
                                    <div className='ji_filtersec'>
                                        <div className="mobileFilter mobileonly text-end">
                                            <button
                                            className="btn-filter btn-unscroll font-18 font-500"
                                            type="button"
                                            // data-bs-toggle="collapse"
                                            // data-bs-target="#filter_collapse"
                                            // aria-expanded="true"
                                            // aria-controls="filter_collapse"
                                            onClick={handleFilterButtonClick}
                                            >
                                            <span className="icon-filter"></span> Filters
                                            </button>
                                        </div>
                                        <div className="filters leftPaneFilter collapse show" id="filter_collapse">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <button
                                                    className="btn-filter btn-unscroll mobileonly"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target="#filter_collapse"
                                                    aria-expanded="false"
                                                    aria-controls="filter_collapse"
                                                    onClick={handleFilterButtonClick}
                                                    >
                                                    Filters
                                                    </button>
                                                    <h3 className="font-18 font-500 mb-2 mt-2 aos-init aos-animate" data-aos="fade-left" data-aos-delay="1200">
                                                    <span className="icon-filter"></span> Filters
                                                    </h3>
                                                </div>
                                                <button
                                                    onClick={handleClearFilters}
                                                    className="font-14 font-500 text-burgandi text-decoration-underline btn-clear-filters"
                                                    aria-label="Clear all filters"
                                                    style={{ border: 'none', background: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
                                                >
                                                    Clear
                                                </button>

                                            </div>

                                            <CareerFilter onFilterChange={handleFilterChange} resetKey={resetKey} />
                                            
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md">
                                    {/* Main Content */}
                                    <CareerDeepList filters={selectedFilters} />
                                </div>
                                

                                    
                                    
                            </div>
                        </div>
                        {
                            <div
                                className="tab-pane fade"
                                id="careerinterestmatch"
                                role="tabpanel"
                                aria-labelledby="careerinterestmatch-tab">
                                    <CareerInterestMatch />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default TopCareerLayout;
